import { render, staticRenderFns } from "./MediaPackageUpdate.vue?vue&type=template&id=3237ddb4&"
import script from "./MediaPackageUpdate.vue?vue&type=script&lang=js&"
export * from "./MediaPackageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports